<!-- 班组管理   teamAssessment -->
<template>
  <div class="full hideBar" style="background-color: white;">
    <!-- :style="getbackgroundImg" -->
    <div class="flex-center" v-if="dataList.length == 0">
      <div class="item-class" @click="addGroup">
        <img :src="addImg" />
        <span class="button-class">暂无</span>
        <div class="button-class">立即添加</div>
      </div>
    </div>
    <div class="flex-class" v-else>
      <div class="group-class" v-for="(item, i) in dataList" :key="i">
        <div class="normal-info">
          <div class="normal-info-left">设备名称：</div>
          <div class="normal-info-right">{{ item.groupName }}</div>
        </div>
        <div class="normal-info">
          <div class="normal-info-left">上班时间：</div>
          <div class="normal-info-right">{{ item.startTime }} - {{ item.endTime }}</div>
        </div>
        <div class="normal-info">
          <div class="normal-info-left">设备组：</div>
          <div class="normal-info-right">{{ item.deviceGroupName }}</div>
        </div>
        <hr style="width: 100%; height: 1px; background: #cccccc" />

        <div class="button-group">
          <div class="edit-button" @click="edit(item)">编辑</div>
          <!-- <div class='see-button'>查看</div> -->
          <div class="delete-button" @click="deleteTeam(item)">删除</div>
        </div>
      </div>
      <div class="item-class" @click="addGroup">
        <img :src="addImg" />
        <div class="button-class">立即添加</div>
      </div>
      <!-- <div class='group-class' @click='addGroup'>
				<img style='width: 1rem;height: 1rem;' :src='addImg'/>
				<div class='normal-info' style='text-align: center;'>添加</div>
			</div> -->
    </div>
  </div>
</template>

<script type="text/javascript">
import iconButton from "@/components/module/universal/iconButton.vue";
import multipleSelection from "@/components/module/selection/multipleSelection.vue";
import virtualDeviceTree from "@/components/module/tree/virtualDeviceTree.vue";
import infoList from "@/components/module/universal/infoList.vue";
import nomalInputDialog from "@/components/module/dialog/nomalInputDialog.vue";
import teamAssessmentStore from "@/cache/teamAssessmentStore.js";
import resourcesStore from "@/cache/resourcesStore.js";
export default {
  components: {
    iconButton,
    infoList,
    multipleSelection,
    virtualDeviceTree,
    nomalInputDialog,
  },
  props: [],
  data() {
    return {
      nowGroup: undefined,
      count: 0,

      backgroundImg: undefined,
    };
  },
  created() {
    debugPage = this;
    teamAssessmentStore.getters.getAllTimeTemplate;
  },
  mounted() {
    this.backgroundImg = resourcesStore.getters.getResourcesByName(
      "background/bg_whole.png"
    );
  },
  computed: {
    getbackgroundImg() {
      return {
        "background-image": "url(" + this.backgroundImg + ")",
        "background-size": "100% 100%",
        "background-repeat": "no-repeat",
      };
    },
    addImg() {
      return resourcesStore.getters.getResourcesByName("wedoButton/add.png");
    },
    dataList() {
      var data = teamAssessmentStore.getters.getTeamGroupList;
      console.log(data)
      return isempty(data) ? [] : data;
    },
    groupDialogColumns() {
      //找所有应该显示的属性
      return (isUpdate) => {
        //根据当前用户可选的角色列表组装弹出框多选框nowGroup
        var dateList = [];
        for (var i = 0, len = 24; i < len; i++) {
          var label = (i < 10 ? "0" + i : i) + ":00";
          dateList.push(label);
          label = (i < 10 ? "0" + i : i) + ":30";
          dateList.push(label);
        }
        //dateList.push('24:00')
        var list = [
          {
            name: "班组名称",
            pkid: "name",
            type: 0,
            defaultValue: isUpdate == true ? this.nowGroup.groupName : "",
          },
        ];
        var tabList = teamAssessmentStore.getters.getAllTimeTemplate;
        var defaultList;
        if (!isempty(tabList)) {
          defaultList = {};
          // tabList.forEach((i) => {
          //   defaultList[i.pkid] = i.workTime.split(",");
          // });
        }
        var dataList = dateList;
        var data = {
          name: "上班时间",
          pkid: "workTime",
          type: 12,
          slotType: "dataList",
          tabList,
          dataList,
          defaultList,
          getLabel: (item) => {
            return item;
          },
          label: "选择上班时间",
          tablabel: "模板",
          title: "上班时间",
          deleteTemplate: (item, nowItem, callBack) => {
            this.$api.teamAssessmentApi.deleteTimeTemplate(
              item.pkid,
              (res) => {
                this.$dialogMethod.showMessage("删除模板成功");
                teamAssessmentStore.commit("getAllTimeTemplate", res);
                var temp = nowItem.bk;
                temp.tabList = teamAssessmentStore.getters.getAllTimeTemplate;
                var defaultList;
                if (!isempty(temp.tabList)) {
                  defaultList = {};
                  tabList.forEach((i) => {
                    defaultList[i.pkid] = i.workTime.split(",");
                  });
                }
                temp.defaultList = defaultList;
                temp.bk = Object.assign({}, temp);
                callBack(temp);
              },
              (res) => {
                this.$dialogMethod.showMessage(res);
              }
            );
          },
          saveTemplate: (item, nowItem, callBack) => {
            if (item.tab.tabType == "new") {
              this.$api.teamAssessmentApi.addTimeTemplate(
                item.tab.templateName,
                item.selectList.join(","),
                (res) => {
                  this.$dialogMethod.showMessage("保存模板成功");
                  teamAssessmentStore.commit("addTimeTemplate", res);
                  var temp = nowItem.bk;
                  temp.tabList = teamAssessmentStore.getters.getAllTimeTemplate;
                  var defaultList;
                  if (!isempty(temp.tabList)) {
                    defaultList = {};
                    tabList.forEach((i) => {
                      defaultList[i.pkid] = i.workTime.split(",");
                      if (i.pkid == res.pkid) {
                        temp.defaultValue = {
                          selectList: i.workTime.split(","),
                        };
                      }
                    });
                  }

                  // temp.defaultValue={'selectList':this.nowGroup.workTime.split(',') }

                  temp.defaultList = defaultList;
                  temp.bk = Object.assign({}, temp);
                  callBack(temp);
                },
                (res) => {
                  this.$dialogMethod.showMessage(res);
                }
              );
            } else if (item.tab.pkid) {
              this.$api.teamAssessmentApi.updateTimeTemplate(
                item.tab.pkid,
                item.tab.templateName,
                item.selectList.join(","),
                (res) => {
                  teamAssessmentStore.commit("updateTemplate", res);
                  var temp = nowItem.bk;
                  temp.tabList = teamAssessmentStore.getters.getAllTimeTemplate;
                  var defaultList;
                  if (!isempty(temp.tabList)) {
                    defaultList = {};
                    tabList.forEach((i) => {
                      defaultList[i.pkid] = i.workTime.split(",");
                    });
                  }
                  temp.defaultList = defaultList;
                  temp.bk = Object.assign({}, temp);
                  callBack(temp);
                },
                (res) => {
                  this.$dialogMethod.showMessage(res);
                }
              );
            }
          },
        };
        // if (isUpdate) {
        //   data.defaultValue = {
        //     selectList: this.nowGroup.workTime.split(","),
        //   };
        // }
        data.bk = Object.assign({}, data);
        list.push(data);
        teamAssessmentStore.getters.getDeviceAndTeamTree;
        data = {
          name: "设备组",
          pkid: "deviceGroupId",
          type: 12,
          slotType: "twice",
          label: "选择设备组",
          tablabel: "设备组名称",
          getLabel: (item) => {
            return item.groupName;
          },
          title: "选择设备组",
        };
        if (isUpdate) {
          data.defaultValue = {
            groupName: this.nowGroup.deviceGroupName,
            groupId: this.nowGroup.deviceGroupId,
          };
        }
        data.bk = Object.assign({}, data);
        list.push(data);
        list.push({
          name: "备注",
          pkid: "remarks",
          type: 1,
          defaultValue: isUpdate ? this.nowGroup.remarks : "",
        });
        //根据当前类型添加属性
        return list;
      };
    },
    // 			dataList() {
    // 				var datas = this.$store.orderGroupStore.getters.getGroupsByGroupType('user')
    // 				if (datas == undefined) {
    // 					return []
    // 				} else {
    // 					return datas
    // 				}
    // 			}
  },
  watch: {},
  methods: {
    deleteTeam(item) {
      this.$dialogMethod.openAgreeDialog(
        "删除班组",
        "是否删除 " + item.groupName + "?",
        () => {
          this.$api.teamAssessmentApi.deleteTeamGroup(
            item.groupId,
            (res) => {
              this.$dialogMethod.showMessage("删除成功");
              var index = -1;
              this.dataList.forEach((d, i) => {
                if (d.groupId == item.groupId) {
                  index = i;
                }
              });
              this.dataList.splice(index, 1);
            },
            (res) => {
              this.$dialogMethod.showMessage(res);
            }
          );
        }
      );
    },
    // 			checkGroup(item) {
    // 				this.$set(this, 'nowGroup', item)
    // 			},
    //清空group缓存
    cleanGroupStore() {
      this.$store.orderGroupStore.commit("clear");
    },
    addGroup() {
      var t = this.groupDialogColumns(false);
      for (var i = 0, len = t.length; i < len; i++) {
        var temp = t[i];
        if (
          temp.type == 12 &&
          temp.slotType == "dataList" &&
          temp.tabList == undefined
        ) {
          setTimeout(() => {
            if (this.count > 10) {
              return;
            }
            this.count++;
            this.addGroup();
          }, 100);
          return;
        }
      }
      var dialog = this.$dialogMethod.createDialog(nomalInputDialog);
      dialog.open("新增班组", this.groupDialogColumns(), (result) => {
        if (isempty(result.name)) {
          this.$dialogMethod.showMessage("班组名称不能为空!");
          return false;
        }
        if (isempty(result.startTime) || isempty(result.endTime)) {
          this.$dialogMethod.showMessage("请选择时间段!");
          return false;
        }
        if (isempty(result.deviceGroupId)) {
          this.$dialogMethod.showMessage("请选择设备组!");
          return false;
        }
        var deviceGroupJson = [];
        console.log(result)
        var data = {
          deviceGroupId: result.deviceGroupId.groupId,
          // workTime: result.workTime.selectList.join(","),
          remarks: result.remarks,
          endTime: result.endTime,
          startTime: result.startTime
        };
        deviceGroupJson.push(data);
        this.$api.teamAssessmentApi.addTeamGroup(
          result.name,
          deviceGroupJson,
          (respon) => {
            this.$dialogMethod.showMessage("新建成功!");
            teamAssessmentStore.commit("getTeamGroupList");
          },
          (respon) => {
            this.$dialogMethod.showMessage(respon);
          }
        );
      });
    },
    edit(item) {
      this.nowGroup = item;
      var dialog = this.$dialogMethod.createDialog(nomalInputDialog);
      var d = this.groupDialogColumns(true);
      d[1].workTime = item.startTime
      d[2].workTime = item.endTime
      dialog.open("编辑班组", d, (result) => {
        if (isempty(result.name)) {
          this.$dialogMethod.showMessage("班组名称不能为空!");
          return false;
        }
        if (isempty(result.startTime) || isempty(result.endTime)) {
          this.$dialogMethod.showMessage("请选择时间段!");
          return false;
        }
        if (isempty(result.deviceGroupId)) {
          this.$dialogMethod.showMessage("请选择设备组!");
          return false;
        }
        var deviceGroupJson = [];
        var data = {
          deviceGroupId: result.deviceGroupId.groupId,
          // workTime: result.workTime.selectList.join(","),
          remarks: result.remarks,
          endTime: result.endTime,
          startTime: result.startTime
        };
        deviceGroupJson.push(data);
        this.$api.teamAssessmentApi.updateTeamGroup(
          this.nowGroup.groupId,
          result.name,
          deviceGroupJson,
          (respon) => {
            this.$dialogMethod.showMessage("更新成功!");
            teamAssessmentStore.commit("getTeamGroupList");
          },
          (respon) => {
            this.$dialogMethod.showMessage(respon);
          }
        );
      });
    },
    deleteGroup() {
      if (this.nowGroup == undefined) {
        this.$dialogMethod.showMessage("请先选择一个客户组!");
        return;
      }
      this.$dialogMethod.openAgreeDialog(
        "删除组",
        "是否删除 " + this.nowGroup.name + "?",
        () => {
          this.$api.groupApi.delete(
            this.nowGroup.id,
            (respon) => {
              this.$dialogMethod.showMessage("删除组成功!");
              teamAssessmentStore.commit("getTeamGroupList");
              this.cleanGroupStore();
            },
            (respon) => {
              this.$dialogMethod.showMessage(respon);
            }
          );
        }
      );
    },
  },
};
</script>

<style scoped>
.VirtualDeviceRTValue {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: white;
  
}

.button-class {
  font-size: 0.15rem;
  text-align: center;
  line-height: 0.3rem;
  border-radius: 0.05rem;
  /* color: white; */
  color: #1a1a1a;
  /* background-color: #709AFA; */
  width: 1rem;
  height: 0.3rem;
}

/* .button-class:active {
		background-color: #87B2DE;
		color: black;
	} */

.full {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  overflow-y: scroll;
}

.label-class {
  font-size: 0.15rem;
  line-height: 0.15rem;
  width: 100%;
  height: 0.15rem;
}

.button-group {
  width: 100%;
  height: 0.3rem;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.edit-button {
  background-color: #4771d6;
  color: white;
  font-size: 0.13rem;
  line-height: 0.3rem;
  text-align: center;
  width: 0.8rem;
  height: 0.3rem;
  border-radius: 0.05rem;
  cursor: pointer;
}

.see-button {
  border: 1px solid black;
  background-color: white;
  color: black;
  font-size: 0.12rem;
  line-height: 0.25rem;
  text-align: center;
  width: 0.8rem;
  cursor: pointer;
  height: 0.25rem;
  border-radius: 0.05rem;
}

.delete-button {
  background-color: #d44e34;
  color: white;
  font-size: 0.13rem;
  line-height: 0.3rem;
  text-align: center;
  width: 0.8rem;
  cursor: pointer;
  height: 0.3rem;
  border-radius: 0.05rem;
}

.normal-info {
  height: 0.15rem;
  width: 100%;
  display: flex;
  align-items: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.normal-info-right {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.15rem;
  line-height: 0.16rem;
  height: 0.16rem;
  width: 70%;
}

.normal-info-left {
  /* overflow: hidden; */
  /* text-overflow: ellipsis; */
  /* white-space: nowrap; */
  font-size: 0.15rem;
  line-height: 0.16rem;
  height: 0.16rem;
  width: 30%;
}

.group-class {
  width: 20%;
  margin: 0.1rem;
  background-color: white;
  border-radius: 0.05rem;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  height: 1.5rem;
  padding: 0.2rem 0.2rem 0.1rem;
}

.item-class {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 2rem;
  height: 2rem;
}

.item-class img {
  margin-top: 0.2rem;
  width: 0.6rem;
  height: 0.6rem;
}

.item-class span {
  /* color: white; */
  color: #1a1a1a;
  text-align: center;
}

.flex-center {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

.flex-class {
  width: 98%;
  height: 25%;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
}

.button-label {
  color: #515a6e;
  width: 100%;
  display: flex;
  align-items: center;
  height: 0.37rem;
}
</style>
